// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
  <section id='customer-term-deposits' class="box">
    <sub-header header="'Term deposits'">
      <div class="right-header-panel" ng-if="\$ctrl.profile.status && \$ctrl.profile.status !== 'CLOSED'">
        <div class="switch">
          <input id="closed-table-switch"
                 type="checkbox"
                 ng-model="\$ctrl.showClosed"
                 ng-click="\$ctrl.toggleClosedDeposits()"
                 ng-disabled="\$ctrl.onlyClosedDeposits()"/>
          <label for="closed-table-switch">Show closed deposits</label>
        </div>
        <button class="btn btn-primary" ng-click="\$ctrl.createNew()">Create new</button>
      </div>
    </sub-header>

    <customer-nongroup-access ng-if="\$ctrl.profile.status && \$ctrl.profile.status !== 'CLOSED'"></customer-nongroup-access>

    <form-section>

      <div class="container--with-mini-menu">

        <div>
          <table class="table" at-table at-list="\$ctrl.visibleDeposits">
            <thead></thead>
            <tbody class="tbody">
            <tr ng-click="\$ctrl.selectDeposit(item)"
                ng-class="{'selected': item == \$ctrl.selectedDeposit}"
                class="table__row--clickable">
              <td at-title="No">
                {{\$index+1}}
              </td>
              <td at-implicit at-attribute="productName" at-title="Deposit name"></td>
              <td at-title="Deposit number">
                {{\$ctrl.formatProductAndExtraNumber(item)}}
              </td>
              <td at-title="Maturity date">
                {{item.maturityDate | prettyDate}}
              </td>
              <td at-title="Status">
                {{item.status | translate:'TERM_DEPOSIT'}}
              </td>
              <td at-title="Total balance">
                <span ng-class="{'currency--positive': (item.balance + item.holdsBalance) > 0, 'currency--negative': (item.balance + item.holdsBalance) < 0}">
                  {{item.balance + item.holdsBalance | nxCurrency}}
                </span>
              </td>
              <td at-title="Available balance">
                <span ng-class="{'currency--positive': item.balance > 0, 'currency--negative': item.balance < 0}">
                  {{item.balance | nxCurrency}}
                </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="mini-menu right-details" ng-if="\$ctrl.selectedDeposit">
          <ul class="nav-tabs">
            <li class="active"><a data-target="#operations" data-toggle="tab">Operations</a></li>
            <li><a data-target="#details" data-toggle="tab">Details</a></li>
            <li><a data-target="#interests" data-toggle="tab">Interests</a></li>
            <li><a data-target="#owners" data-toggle="tab">{{\$ctrl.isCorporate ? "Signatories" : "Owners"}}</a></li>
          </ul>

          <div class="tab-content">
            <div class="tab-pane active" id="operations">
              <div class="operation-row">

                <div class="btn-group" command-access="DepositCashPlacement, DepositCheckPlacement, DepositTransferPlacement, DepositMemoPlacement">
                  <button class="btn dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                          ng-disabled="!\$ctrl.placementAllowed()"
                          ng-class="{'btn-success': \$ctrl.placementAllowed(), 'btn-default': !\$ctrl.placementAllowed()}">
                    Placement
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li command-access="DepositCashPlacement">
                      <a ng-click="\$ctrl.cashPlacement()">
                        Cash
                      </a>
                    </li>
                    <li command-access="DepositCheckPlacement">
                      <a ng-click="\$ctrl.checkPlacement()">
                        Check
                      </a>
                    </li>
                    <li command-access="DepositMemoPlacement">
                      <a ng-click="\$ctrl.memoPlacement()">
                        Memo
                      </a>
                    </li>
                    <li command-access="DepositTransferPlacement">
                      <a ng-click="\$ctrl.transferPlacement()">
                        Transfer
                      </a>
                    </li>
                  </ul>
                </div>

                <button type="button" command-access="DepositTermDepositFundsByMemo"
                        class="btn"
                        ng-class="{'btn-success': \$ctrl.creditMemoAllowed(), 'btn-default': !\$ctrl.creditMemoAllowed()}"
                        ng-disabled="!\$ctrl.creditMemoAllowed()"
                        ng-click="\$ctrl.creditMemo()">
                  Credit Memo
                </button>
                <button type="button"
                        class="btn btn-primary"
                        ng-if="\$ctrl.hasActiveCertificate() && \$ctrl.certificateIssueAvailable()"
                        ng-click="\$ctrl.reprintCertificate()">
                  Reprint certificate
                </button>

                <div class="btn-group" command-access="WithdrawDepositInterestByCash, WithdrawDepositInterestByCheck, InterestsTransferToProduct">
                  <button class="btn dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                          ng-disabled="!\$ctrl.anyWithdrawalAllowed()"
                          ng-class="{'btn-danger': \$ctrl.anyWithdrawalAllowed(), 'btn-default': !\$ctrl.anyWithdrawalAllowed()}">
                    Interest Withdr.
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li command-access="WithdrawDepositInterestByCash"
                        ng-if="\$ctrl.cashWithdrawalAllowed()">
                      <a ng-click="\$ctrl.interestsCashWithdrawal()">
                        Cash
                      </a>
                    </li>
                    <li command-access="WithdrawDepositInterestByCheck"
                        ng-if="\$ctrl.checkWithdrawalAllowed()">
                      <a ng-click="\$ctrl.interestsCheckWithdrawal()">
                        Check
                      </a>
                    </li>
                    <li command-access="InterestsTransferToProduct"
                        ng-if="\$ctrl.transferToProductAllowed()">
                      <a ng-click="\$ctrl.interestsTransferToProduct()">
                        Transfer To Product
                      </a>
                    </li>
                  </ul>
                </div>
                <button type="button" command-access="WithdrawTermDepositFundsByMemo"
                        class="btn"
                        ng-class="{'btn-danger': \$ctrl.debitMemoAllowed(), 'btn-default': !\$ctrl.debitMemoAllowed()}"
                        ng-disabled="!\$ctrl.debitMemoAllowed()"
                        ng-click="\$ctrl.debitMemo()">
                  Debit Memo
                </button>
                <div class="btn-group"
                     command-access="UpdateDeposit, UpdateDepositSignatureCard">
                  <button class="btn dropdown-toggle"
                          data-toggle="dropdown"
                          ng-disabled="!\$ctrl.editAvailable()"
                          ng-class="{'btn-warning': \$ctrl.selectedDeposit.status !== 'CLOSED', 'btn-default': \$ctrl.selectedDeposit.status === 'CLOSED'}">
                    Edit <span class="caret">
                  </span>
                  </button>
                  <ul class="dropdown-menu">
                    <li command-access="UpdateDeposit"><a ng-click="\$ctrl.edit()">Edit parameters</a></li>
                    <li command-access="UpdateDepositSignatureCard"><a ng-click="\$ctrl.editSignatureCard()">Edit signature card</a></li>
                  </ul>
                </div>
                <signature-card
                  file-id="\$ctrl.selectedDeposit.signatureCardFileId"
                  product-group="'DEPOSIT'"
                  product-status="\$ctrl.selectedDeposit.status"
                ></signature-card>

                <div class="btn-group" command-access="CashDepositPretermination, CheckDepositPretermination, MemoDepositPretermination">
                  <button class="btn dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                          ng-disabled="!\$ctrl.terminationAllowed()"
                          ng-class="{'btn-danger': \$ctrl.terminationAllowed(), 'btn-default': !\$ctrl.terminationAllowed()}">
                    Terminate
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li command-access="CashDepositPretermination">
                      <a ng-click="\$ctrl.terminateWithCash()">
                        Terminate with cash
                      </a>
                    </li>
                    <li command-access="CheckDepositPretermination">
                      <a ng-click="\$ctrl.terminateWithCheck()">
                        Terminate with check
                      </a>
                    </li>
                    <li command-access="MemoDepositPretermination">
                      <a ng-click="\$ctrl.terminateWithMemo()">
                        Terminate with memo
                      </a>
                    </li>
                  </ul>
                </div>
                <button type="button" class="btn btn-default"
                        command-access="DepositManualRollover"
                        ng-class="{'btn-success': \$ctrl.rolloverAllowed(), 'btn-default': !\$ctrl.rolloverAllowed()}"
                        ng-disabled="!\$ctrl.rolloverAllowed()"
                        ng-click="\$ctrl.rollover()">
                  Manual Rollover
                </button>
                <button type="button" class="btn"
                        command-access="CloseTermDeposit"
                        ng-class="{'btn-danger': \$ctrl.closingAllowed(), 'btn-default': !\$ctrl.closingAllowed()}"
                        ng-disabled="!\$ctrl.closingAllowed()"
                        ng-click="\$ctrl.close()">
                  Close
                </button>

                <button type="button" class="btn"
                        command-access="DepositWithdrawalTransferToProduct"
                        ng-class="{'btn-danger': \$ctrl.partialWithdrawalAllowed(), 'btn-default': !\$ctrl.partialWithdrawalAllowed()}"
                        ng-disabled="!\$ctrl.partialWithdrawalAllowed()"
                        ng-click="\$ctrl.transferToProduct()">
                  Transfer to product
                </button>
                <button type="button" class="btn"
                        command-access="DepositPartialWithdrawalCash"
                        command-access="CashDepositPretermination"
                        ng-class="{'btn-danger': \$ctrl.partialWithdrawalAllowed(), 'btn-default': !\$ctrl.partialWithdrawalAllowed()}"
                        ng-disabled="!\$ctrl.partialWithdrawalAllowed()"
                        ng-click="\$ctrl.partialWithdrawalCash()">
                  Partial Cash Withdr.
                </button>
                <button type="button" class="btn"
                        command-access="DepositPartialWithdrawalCheck"
                        ng-class="{'btn-danger': \$ctrl.partialWithdrawalAllowed(), 'btn-default': !\$ctrl.partialWithdrawalAllowed()}"
                        ng-disabled="!\$ctrl.partialWithdrawalAllowed()"
                        ng-click="\$ctrl.partialWithdrawalCheck()">
                  Partial Check Withdr.
                </button>
                <button type="button" class="btn"
                        command-access="CreateManualHold"
                        ng-class="{'btn-danger': \$ctrl.createHoldAvailable(), 'btn-default': !\$ctrl.createHoldAvailable()}"
                        ng-click="\$ctrl.createHold()"
                        ng-disabled="!\$ctrl.createHoldAvailable()">
                  Create Hold
                </button>
                <button type="button"
                        class="btn"
                        command-access="CreateTermDepositCertificate"
                        ng-class="{'btn-warning': \$ctrl.certificateIssueAvailable()}"
                        ng-click="\$ctrl.issueCertificate()"
                        ng-if="\$ctrl.certificateIssueAvailable()">
                  Issue Certificate
                </button>
                <button type="button"
                        class="btn"
                        command-access="CreateTermDepositPassbook"
                        ng-class="{'btn-warning': \$ctrl.passbookIssueAvailable(), 'btn-default': !\$ctrl.passbookAvailable()}"
                        ng-click="\$ctrl.issuePassbook()"
                        ng-if="\$ctrl.passbookIssueAvailable()">
                  Issue Passbook
                </button>

                <button type="button"
                        class="btn"
                        command-access="CreateProductLock"
                        ng-class="{'btn-danger': \$ctrl.createLockAvailable(), 'btn-default': !\$ctrl.createLockAvailable()}"
                        ng-click="\$ctrl.createLock()"
                        ng-disabled="!\$ctrl.createLockAvailable()">
                  Create Lock
                </button>
                <button type="button"
                        class="btn"
                        command-access="BatchReleaseProductLock"
                        ng-class="{'btn-success': \$ctrl.releaseLockAvailable(), 'btn-default': !\$ctrl.releaseLockAvailable()}"
                        ng-click="\$ctrl.releaseLock()"
                        ng-disabled="!\$ctrl.releaseLockAvailable()">
                  Release Locks
                </button>
              </div>
            </div>

            <div class="tab-pane" id="details">
              <div class="detail-rows">
                <div class="info-detail">
                  <span class="key">Deposit subgroup:</span>
                  <span class="value">{{\$ctrl.selectedDeposit.depositSubgroup | prettyEnum}}</span>
                </div>
                <div class="info-detail"><span class="key">Status:</span><span class="value">{{\$ctrl.selectedDeposit.status | prettyEnum}}</span></div>
                <div class="info-detail"><span class="key">Term in days:</span><span class="value">{{\$ctrl.selectedDeposit.depositTerm}}</span></div>
                <div class="info-detail"><span class="key">Maturity date:</span><span class="value">{{\$ctrl.selectedDeposit.maturityDate | nxDate}}</span></div>
                <div class="info-detail"><span class="key">Maturity value:</span><span class="value">{{\$ctrl.selectedDeposit.maturityValue | nxCurrency}}</span></div>
                <div class="info-detail"><span class="key">Activation date:</span><span class="value">{{\$ctrl.selectedDeposit.activatedOn | nxDate}}</span></div>
                <div class="info-detail"
                    ng-if="\$ctrl.activeCertificate">
                    <span class="key">Certificate number:</span>
                    <span class="value">{{\$ctrl.activeCertificate.number}}</span>
                </div>
                <div class="info-detail"><span class="key">Certification date:</span><span class="value">{{\$ctrl.selectedDeposit.certifiedOn | nxDate}}</span></div>
                <div class="info-detail"><span class="key">Principal:</span><span class="value">{{\$ctrl.selectedDeposit.balance | nxCurrency}}</span></div>
                <div class="info-detail"><span class="key">Tax exempted</span><span class="value">{{\$ctrl.selectedDeposit.taxExempted | prettyBoolean}}</span></div>
                <div class="info-detail"><span class="key">On maturity:</span><span class="value">{{\$ctrl.selectedDeposit.maturityStrategy | translate:'TERM_DEPOSIT'}}</span></div>
                <div class="info-detail" ng-if="\$ctrl.selectedDeposit.pledgePaymentInterval">
                  <span class="key">Pledge deposit interval:</span><span class="value">{{\$ctrl.getPledgePaymentIntervalLabel(\$ctrl.selectedDeposit.pledgePaymentInterval)}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Deviated:</span><span class="value">{{\$ctrl.selectedDeposit.deviated | prettyBoolean}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Force overmature interest rate:</span><span class="value">{{\$ctrl.selectedDeposit.earlyOvermatureInterestRateAppliedOn != null | prettyBoolean}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Outstanding Placement Fees:</span><span class="value">{{\$ctrl.selectedDeposit.placementFeeBalance | nxCurrency}}</span>
                </div>
                <div class="info-detail"><span class="key">Created on:</span><span class="value">{{\$ctrl.selectedDeposit.createdOn}}</span></div>
                <div class="info-detail"><span class="key">Created by:</span><span class="value">{{\$ctrl.selectedDeposit.createdBy}}</span></div>
                <div class="info-detail"><span class="key">Created in branch:</span><span class="value">{{\$ctrl.selectedDeposit.branchName}}</span></div>
                <div class="info-detail" ng-if="\$ctrl.selectedDeposit.depositSubgroup === 'PLEDGE'">
                  <span class="key">Initial placement type:</span>
                  <span class="value">{{\$ctrl.selectedDeposit.initialPlacementType | prettyEnum}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedDeposit.depositSubgroup === 'PLEDGE'">
                  <span class="key">Pledge ADB:</span><span class="value">{{\$ctrl.selectedDeposit.adb | nxCurrency}}</span>
                </div>
                <div ng-if="\$ctrl.selectedDeposit.relatedAccountName" class="info-detail">
                  <span class="key">Related account:</span><span class="value">{{\$ctrl.selectedDeposit.relatedAccountName}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Last signature upload date:</span>
                  <span class="value">{{(\$ctrl.selectedDeposit.lastUpdateSignatureCardOn | prettyDate) || '-'}}</span>
                </div>
                <div ng-if="\$ctrl.selectedDeposit.extraNumber" class="info-detail">
                  <span class="key">Extra number:</span>
                  <span class="value">{{\$ctrl.selectedDeposit.extraNumber || '-'}}</span>
                </div>
              </div>
            </div>

            <div class="tab-pane" id="interests">
              <div class="detail-rows">
                <div class="info-detail">
                  <span class="key">Special rate:</span>
                  <span class="value">{{\$ctrl.selectedDeposit.depositInterest.specialInterestRate | prettyBoolean}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Standard interest rate:</span>
                  <span class="value">{{\$ctrl.selectedDeposit.depositInterest.interestRate}}%</span>
                </div>
                <div class="info-detail">
                  <span class="key">Pretermination (first half) interest rate:</span>
                  <span class="value">{{\$ctrl.selectedDeposit.depositInterest.preterminationFirstHalfInterestRate}}%</span>
                </div>
                <div class="info-detail">
                  <span class="key">Pretermination (second half) interest rate:</span>
                  <span class="value">{{\$ctrl.selectedDeposit.depositInterest.preterminationSecondHalfInterestRate}}%</span>
                </div>
                <div class="info-detail">
                  <span class="key">Overmature interest rate:</span>
                  <span class="value">{{\$ctrl.selectedDeposit.depositInterest.overmatureInterestRate}}%</span>
                </div>
                <div class="info-detail">
                  <span class="key">Withholding tax rate:</span>
                  <span class="value">{{\$ctrl.selectedDeposit.withholdingTaxRate}}%</span>
                </div>
                <div class="info-detail">
                  <span class="key">Accrued interest:</span>
                  <span class="value">{{\$ctrl.selectedDeposit.accruedInterest | nxCurrency}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Last accrual:</span>
                  <span class="value" ng-if="!\$ctrl.selectedDeposit.lastAccrualDate">N/A</span>
                  <span class="value" ng-if="\$ctrl.selectedDeposit.lastAccrualDate">{{\$ctrl.selectedDeposit.lastAccrualDate | prettyDate}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Last crediting:</span>
                  <span class="value" ng-if="!\$ctrl.selectedDeposit.creditingScheduler.lastExecution">N/A</span>
                  <span class="value" ng-if="\$ctrl.selectedDeposit.creditingScheduler.lastExecution">{{\$ctrl.selectedDeposit.creditingScheduler.lastExecution | prettyDate}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Crediting strategy:</span>
                  <span class="value">{{\$ctrl.selectedDeposit.creditingStrategy | translate:'TERM_DEPOSIT'}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Crediting enabled:</span>
                  <span class="value">{{\$ctrl.selectedDeposit.creditingScheduler.enabled | prettyBoolean}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Crediting interval:</span>
                  <span class="value" ng-if="!\$ctrl.selectedDeposit.creditingScheduler.enabled">N/A</span>
                  <span class="value" ng-if="\$ctrl.selectedDeposit.creditingScheduler.enabled">{{\$ctrl.selectedDeposit.creditingScheduler.interval}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Crediting cycle type:</span>
                  <span class="value" ng-if="!\$ctrl.selectedDeposit.creditingScheduler.enabled">N/A</span>
                  <span class="value" ng-if="\$ctrl.selectedDeposit.creditingScheduler.enabled">{{\$ctrl.selectedDeposit.creditingScheduler.cycleType | prettyEnum}}</span>
                </div>
              </div>
            </div>

            <div class="tab-pane" id="owners">
              <table class="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th ng-if="\$ctrl.isCorporate">Withdrawal limit</th>
                    <th ng-if="!\$ctrl.isCorporate">PDIC</th>
                    <th class="signature">Signature</th>
                  </tr>
                </thead>
                <tbody>
                  <tr ng-repeat="owner in \$ctrl.getOwnership(\$ctrl.selectedDeposit.ownership, \$ctrl.isCorporate)">
                    <td>
                      <span ng-if="owner.customerId == \$ctrl.profile.id">{{owner.effectiveName}}</span>
                      <a ng-click="\$ctrl.switchContext(owner)"
                         ng-if="owner.customerId != \$ctrl.profile.id"
                         class="link">
                        <span >{{owner.effectiveName}}</span>
                      </a>
                    </td>
                    <td>
                      <span>{{owner.ownershipType | translateEnum:'PRODUCT'}}</span>
                    </td>
                    <td ng-if="\$ctrl.isCorporate">
                      <span>{{owner.relative ? (owner.relative.withdrawalLimit | nxCurrency) : ''}}</span>
                    </td>
                    <td ng-if="!\$ctrl.isCorporate">
                      {{\$ctrl.selectedDeposit.pdicTypeName}}
                    </td>
                    <td class="signature">
                      <signature-card file-id="owner.signatureFileId" use-icon-button="true"></signature-card>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </form-section>

    <div class="tab-menu">
      <ul class="nav-tabs">
        <li class="active">
          <a data-target="#tab_transactions" data-toggle="tab">
            <span>Transaction history</span>
          </a>
        </li>
        <li ng-if="\$ctrl.hasActivePassbook()">
          <a data-target="#tab_passbook" data-toggle="tab">
            <span>Passbook (No: {{\$ctrl.activePassbook.number}})</span>
          </a>
        </li>
        <li>
          <a data-target="#tab_holds" data-toggle="tab">
            <span>Holds</span>
          </a>
        </li>
        <li>
          <a data-target="#tab_locks" data-toggle="tab">
            <span>Locks</span>
          </a>
        </li>
        <li ng-if="\$ctrl.selectedDeposit.pledgeInstallments.length > 0">
          <a data-target="#tab_pledge" data-toggle="tab">
            <span>Pledge installment schedule</span>
          </a>
        </li>
        <li ng-if="\$ctrl.selectedAdvanceInterestLedger">
          <a data-target="#tab_advanced_interest" data-toggle="tab">
            <span>Advance interest ledger</span>
          </a>
        </li>
        <li>
          <a data-target="#note_history" data-toggle="tab">
            <span>Note History</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="tab-content" style="overflow: unset">

      <div class="tab-pane active" id="tab_transactions">
        <form-section class="history">
          <transaction-history
            product="\$ctrl.selectedDeposit"
            groups="\$ctrl.groups"
            item="\$ctrl.item"
            product-type="'TERM-DEPOSIT'">
            <div class="inline-panel__container" ng-repeat="keyValueItem in \$ctrl.keyValueDetails(\$ctrl.item)">
              <label class="inline-panel__label">{{keyValueItem.label}}:</label>
              <p class="inline-panel__value">{{keyValueItem.value}}</p>
            </div>
            <section>
              <span>
              <button
                type="button"
                ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                  && \$ctrl.item.operationGroup == 'DEPOSIT_CASH'"
                command-access="DepositCashPlacementRevert"
                class="btn btn-danger"
                ng-click="\$ctrl.revertCashPlacement(\$ctrl.item)">
                Revert
              </button>
              <button
                type="button"
                ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                  && (\$ctrl.item.operationGroup == 'DEPOSIT_CHECK' || \$ctrl.item.operationGroup == 'DEPOSIT_CUTOFF_CHECK')"
                command-access="DepositCheckPlacementRevert"
                class="btn btn-danger"
                ng-click="\$ctrl.revertCheckPlacement(\$ctrl.item)">
                Revert
              </button>
              <button
                type="button"
                ng-if=" \$ctrl.revertAllowed(\$ctrl.item)
                  && (\$ctrl.item.operationGroup == 'TRANSFER_FUNDS' && \$ctrl.item.operationSubgroup == 'CREDIT_CHECK_ON_US')"
                command-access="DepositCheckPlacementByOnUsCheckRevert"
                class="btn btn-danger"
                ng-click="\$ctrl.revertCheckPlacement(\$ctrl.item)">
                Revert
              </button>
              <button
                type="button"
                ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                  && \$ctrl.item.operationGroup == 'CREDIT_MEMO'
                  && \$ctrl.item.operationSubgroup !== 'TERM_DEPOSIT_PLACEMENT'"
                command-access="TermDepositCreditMemoRevert"
                class="btn btn-danger"
                ng-click="\$ctrl.revertCreditMemo(\$ctrl.item)">
                Revert
              </button>
              <button
                type="button"
                ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                  && \$ctrl.item.operationGroup == 'CREDIT_MEMO'
                  && \$ctrl.item.operationSubgroup === 'TERM_DEPOSIT_PLACEMENT'"
                command-access="DepositMemoPlacementRevert"
                class="btn btn-danger"
                ng-click="\$ctrl.revertCreditMemo(\$ctrl.item)">
                Revert
              </button>
              <button
                type="button"
                ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                  && (\$ctrl.item.operationGroup == 'DEBIT_MEMO'
                  && \$ctrl.item.attributes.TERMINATION_TYPE != 'PRETERMINATION')"
                command-access="TermDepositDebitMemoRevert"
                class="btn btn-danger"
                ng-click="\$ctrl.revertDebitMemo(\$ctrl.item)">
                Revert
              </button>
              <button
                type="button"
                ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                     && \$ctrl.item.operationGroup === 'TRANSFER_FUNDS'
                     && \$ctrl.item.operationSubgroup === 'REGULAR'
                     && \$ctrl.item.rootCommandId == null
                     && !\$ctrl.item.attributes['AUTOMATIC_DEBIT']"
                command-access="DepositTransferPlacementRevert"
                class="btn btn-danger"
                ng-click="\$ctrl.revertInternalTransfer(\$ctrl.item)">
                Revert
              </button>
              <button
                type="button"
                ng-if="\$ctrl.revertAllowed(\$ctrl.item, 'DepositAutomaticDebitPlacementRevert')
                  && \$ctrl.item.operationGroup == 'TRANSFER_FUNDS'
                  && \$ctrl.item.attributes['AUTOMATIC_DEBIT'] == 'true'"
                command-access="DepositAutomaticDebitPlacementRevert"
                class="btn btn-danger"
                ng-click="\$ctrl.revertAda(\$ctrl.item)">
                Revert
              </button>
            </span>
              <button
                type="button"
                class="btn btn-primary"
                ng-if="\$ctrl.isValidationSlipActive && \$ctrl.isValidationSlipSupported(\$ctrl.item)"
                ng-click="\$ctrl.showPrint(\$ctrl.item)">
                Print validation
              </button>
              <button
                type="button"
                ng-if="\$ctrl.item.operationGroup == 'CLEAR_CHECK'
                      && (['PENDING', 'PROCESSED'].includes(\$ctrl.item.status))
                      && !\$ctrl.hasReturnCheckOperation(\$ctrl.item)"
                command-access="ReturnDepositCheck"
                class="btn btn-danger"
                ng-click="\$ctrl.returnCheck(\$ctrl.item)">
                Return check
              </button>
            <button
              type="button"
              ng-if="\$ctrl.isComputationSheetAvailable(\$ctrl.item)"
              class="btn btn-info"
              ng-click="\$ctrl.printComputationSheet(\$ctrl.item)">
              Computation
            </button>
            </section>
          </transaction-history>
        </form-section>
      </div>

      <div id="tab_passbook" class="passbook tab-pane" ng-if="\$ctrl.hasActivePassbook()">
        <passbook
          renderable-prints="[{'code':'TERM_DEPOSIT_PASSBOOK'}, {'code':'TERM_DEPOSIT_PASSBOOK_SLIP','requires':'type.enablePassbookSlip'}]"
          product="\$ctrl.selectedDeposit"
          customer-id="\$ctrl.profile.id"
          product-group="'TERM_DEPOSIT'"
          passbook-obj="\$ctrl.activePassbook">
        </passbook>
      </div>

      <div id="tab_holds" class="holds tab-pane">
        <product-holds product="\$ctrl.selectedDeposit"></product-holds>
      </div>

      <div id="tab_locks" class="locks tab-pane">
        <product-locks ng-if="\$ctrl.selectedDeposit" product="\$ctrl.selectedDeposit"></product-locks>
      </div>

      <div
        id="tab_pledge"
        class="locks tab-pane"
        ng-if="\$ctrl.selectedDeposit.pledgeInstallments.length > 0">
        <button class="btn btn-success print-pledge-btn" ng-click="\$ctrl.printPledgeInstallmentSchedule()" type="button">
          Print
        </button>
        <pledge-installments
          installments="\$ctrl.selectedDeposit.pledgeInstallments"
          grace-period-days="\$ctrl.selectedDeposit.pledgeGracePeriodDays"
          simulation-mode="false">
        </pledge-installments>
      </div>

      <div
        id="tab_advanced_interest"
        class="locks tab-pane"
        ng-if="\$ctrl.selectedAdvanceInterestLedger">
        <div class="detail-rows">
          <div class="info-detail">
            <span class="key">Term:</span>
            <span class="value">
              <select
                ng-model="\$ctrl.selectedDepositTerm"
                ng-options="t.id as t.maturityDate for t in \$ctrl.depositTerms"
                ng-change="\$ctrl.selectAdvanceInterestLedger()">
              </select>
            </span>
          </div>
        </div>
        <advance-interest-ledger
          ledger="\$ctrl.selectedAdvanceInterestLedger">
        </advance-interest-ledger>
      </div>


      <div class="tab-pane" id="note_history">
        <note-history product-id="\$ctrl.selectedDeposit.id"
                      product-type="'DEPOSIT'"></note-history>
      </div>
    </div>
  </section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/customer-term-deposits.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;